import { render } from "./ConsultationConsole.vue?vue&type=template&id=b26b9de4&scoped=true"
import script from "./ConsultationConsole.vue?vue&type=script&lang=js"
export * from "./ConsultationConsole.vue?vue&type=script&lang=js"

import "./ConsultationConsole.vue?vue&type=style&index=0&id=b26b9de4&lang=css"
import "./ConsultationConsole.vue?vue&type=style&index=1&id=b26b9de4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26b9de4"]])

export default __exports__